import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MCPConfig } from '@shared/index';
import { firstValueFrom } from 'rxjs';
import { BotService } from './bot.service';

@Injectable({
  providedIn: 'root'
})
export class MiroService {

  private http = inject(HttpClient);
  private botService = inject(BotService);

  constructor() {
    void firstValueFrom(this.http.get<MCPConfig[]>("/api/user/mcp/getmanaged/" + this.botService.botConfig?._id)).then((v: MCPConfig[]) => {
       
      const hasMiroMCP = v.some(mcp => mcp.type === "managed" && mcp.toolName === "miro");
      if (hasMiroMCP) {
        if (!window.RAGAI.loggedInUser?.miroAuth) {
          if (window.top) {
            const redirect_uri = encodeURIComponent(window.top.location.origin + '/' + window.top.location.pathname.split("/")[1] + "/auth/miro");
            const state = btoa(encodeURIComponent(window.top.location.pathname.substring(3).split("/").filter(s => s != "").join("/")));
            const href = `https://miro.com/app-install/?response_type=code&client_id=3458764664985448357&redirect_uri=${redirect_uri}&state=${state}`;
            window.top.location.href = href;
          }
        }
      }
    });
  }

  public async copyMiroBoard(copy_from: string, options?: {
    description?: string;
    name?: string;
    policy?: unknown;
    teamId?: string;
  }) {
    return await firstValueFrom(this.http.put("/api/user/miro/copyboard", { copy_from, options }));
  }

  public async updateMiroBoard(boardId: string, name: string) {
    return await firstValueFrom(this.http.patch<{ status: "ok" }>("/api/user/miro/updateboard/" + boardId, { name }));
  }


}
